export default "__VITE_ASSET__Dvp7Oh2K__"